
import { useState } from 'react';

const faqData = [
  {
    question: 'Why do small parcels cost more per acre?',
    answer:
      "Fixed costs like mobilization, flight planning, equipment setup, and reporting don't scale linearly. A 25-acre survey requires the same setup as a 500-acre survey. Above 500 acres, economies of scale bring per-acre costs down to base rates.",
  },
  {
    question: "What's included in each service type?",
    answer:
      'Timber Inventory includes stand mapping, density analysis, and access documentation. Forest Health adds multispectral stress detection. LiDAR surveys provide 3D canopy and terrain models. Pre-Acquisition packages combine multiple data layers for investment decisions. Post-Storm assessments focus on rapid damage documentation.',
  },
  {
    question: 'How fast are results delivered?',
    answer:
      'Standard turnaround ranges from 5 to 14 business days depending on service type and project size. Priority turnaround delivers results within 72 hours for an additional 15%. Post-storm assessments are prioritized by default.',
  },
  {
    question: 'What affects final pricing beyond acreage?',
    answer:
      'Terrain steepness, canopy density, site accessibility, number of distinct stands, and deliverable requirements all influence final scope. The calculator provides a planning estimate; firm quotes account for these site-specific factors.',
  },
  {
    question: 'Can I bundle multiple service types?',
    answer:
      'Yes. Combining services on the same flight reduces mobilization costs. For example, pairing RGB inventory with multispectral health analysis is more cost-effective than scheduling them separately. Contact us for bundled pricing.',
  },
  {
    question: 'How does recurring monitoring save money?',
    answer:
      'Annual surveys save 10% per visit and semi-annual surveys save 15%. Recurring clients benefit from established baselines, faster processing, and no repeat mobilization fees. Change detection is also more accurate with consistent survey intervals.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // Toggle the currently open FAQ item; safely ignore invalid indices
  const handleToggle = (index: number) => {
    if (typeof index !== 'number' || index < 0) return;
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-stone-900 mb-4">Pricing Questions</h2>
          <p className="text-lg text-stone-600">
            Common questions about timber and forestry pricing
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg border border-stone-200 overflow-hidden"
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-stone-50 transition-colors cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="font-semibold text-stone-900 pr-4 text-sm">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-stone-400`}
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div
                  id={`faq-answer-${index}`}
                  className="px-6 pb-5"
                >
                  <p className="text-sm text-stone-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
